import StartPostButton from './StartPostButton';

export default StartPostButton;
